import _get from "lodash/get";
import { isAuthenticateAction, isUnauthenticateAction } from "../utils/auth";
import { preloadIdentity, requestIdentity } from "../actions";
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = action.payload; // Handle auth-related actions

  if (isAuthenticateAction(action)) {
    return true;
  }

  if (isUnauthenticateAction(action)) {
    return false;
  } // Handle non-auth-related actions


  switch (action.type) {
    case requestIdentity.SUCCESS_TYPE:
      return true;

    case preloadIdentity.getType():
      return !!_get(payload, 'IdentityStore.currentIdentity');

    default:
      return state;
  }
});